<section class="legacy-cta-section d-flex align-items-center">
    <div class="container py-5">
      <div class="row justify-content-center">
        <div class="col-12 col-xl-10 text-center">

          <!-- kicker -->
          <div class="d-flex justify-content-center align-items-center gap-3 text-uppercase text-xs fw-semibold legacy-kicker mb-3">
            <span class="legacy-kicker-line"></span>
            <span>{{ cta_data.kicker }}</span>
          </div>

          <!-- title -->
          <h2 class="legacy-title mb-3">
            {{ cta_data.title_line_1 }}<br />
            {{ cta_data.title_line_2 }}
          </h2>

          <!-- subtitle -->
          <p class="legacy-subtitle mb-5">
            <span class="legacy-subtitle-accent">{{ cta_data.subtitle_accent }}</span>
            <span class="legacy-subtitle-rest"> {{ cta_data.subtitle_rest }}</span>
          </p>

          <!-- asset pills -->
          <div class="row justify-content-center g-3 mb-5">
            <div
              v-for="asset in assets"
              :key="asset.key"
              class="col-12 col-sm-6 col-lg-3"
            >
              <button
                type="button"
                class="legacy-pill w-100 text-center"
                :class="{ active: selected_asset_key === asset.key }"
                @click="select_asset(asset.key)"
              >
                <div class="legacy-pill-title">
                  {{ asset.title }}
                </div>
                <div class="legacy-pill-meta text-xs">
                  {{ asset.meta }}
                </div>
              </button>
            </div>
          </div>

          <!-- main CTA -->
          <a
            :href="cta_data.cta_link"
            class="legacy-main-cta d-inline-flex align-items-center justify-content-center gap-2 text-uppercase text-xs fw-semibold text-decoration-none"
          >
            <span>{{ cta_data.cta_text }}</span>
            <span aria-hidden="true">→</span>
          </a>

          <!-- quote -->
          <div class="mt-5 pt-4 legacy-quote-wrap">
            <p class="legacy-quote mb-0">
              “{{ cta_data.quote }}”
            </p>
          </div>

        </div>
      </div>
    </div>
  </section>
